import Mutations from '../../odata/mutations';

export default { ...new Mutations('pricing'), ...new Mutations('pricings') };
